(function () {
  function replaceWishlistIcon() {
    const icon = document.querySelector('.Vtl-WishlistHeader__HeartIconWrapper');

    if (!icon) return;

    // Already replaced
    if (icon.tagName === 'IMG') return;

    const img = document.createElement('img');

    img.src = 'https://cdn.shopify.com/s/files/1/1008/2916/7797/files/fav_brown.svg?v=1786076340';
    img.alt = 'Wishlist';
    img.className = 'Vtl-WishlistHeader__HeartIconWrapper';

    img.style.width = '35px';
    img.style.height = '35px';
    img.style.objectFit = 'contain';

    icon.replaceWith(img);
  }

  // Run after the page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceWishlistIcon);
  } else {
    replaceWishlistIcon();
  }

  // Watch for the wishlist app injecting its icon
  const observer = new MutationObserver(function () {
    replaceWishlistIcon();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();